module.exports = __webpack_public_path__ + "static/img/online-service.c38b3771.png";